var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87417 10.3417L12.135 13.6583M12.1258 4.50833L5.87417 7.825M17.25 3.25C17.25 4.63071 16.0188 5.75 14.5 5.75C12.9812 5.75 11.75 4.63071 11.75 3.25C11.75 1.86929 12.9812 0.75 14.5 0.75C16.0188 0.75 17.25 1.86929 17.25 3.25ZM6.25 9.08333C6.25 10.464 5.01878 11.5833 3.5 11.5833C1.98122 11.5833 0.75 10.464 0.75 9.08333C0.75 7.70262 1.98122 6.58333 3.5 6.58333C5.01878 6.58333 6.25 7.70262 6.25 9.08333ZM17.25 14.9167C17.25 16.2974 16.0188 17.4167 14.5 17.4167C12.9812 17.4167 11.75 16.2974 11.75 14.9167C11.75 13.536 12.9812 12.4167 14.5 12.4167C16.0188 12.4167 17.25 13.536 17.25 14.9167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ca0b725eee94ac05129a948b6ca948d2.svg";
export { ForwardRef as ReactComponent };